import QuoteAndBuyFormConfig from '../../../../form/shared/qb/config'

export default QuoteAndBuyFormConfig
